import { withClassName } from '@/common/theme/withClassName';
import { ButtonWithAnalytics } from './ButtonWithAnalytics';
import styles from './primary-button.module.scss';

export const PrimaryButton = withClassName(
  ButtonWithAnalytics,
  styles.button,
  'PrimaryButton',
);

export const RedesignPrimaryButton = withClassName(
  PrimaryButton,
  styles.redesign,
  'RedesignPrimaryButton',
);

export const RedesignPrimaryButtonStandalone = withClassName(
  PrimaryButton,
  styles.standalone,
  'RedesignPrimaryButtonStandalone',
);
